import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

/** Marca: dois semicírculos que se encaixam (as duas partes) formando um escudo. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('h-8 w-8', className)} aria-hidden="true">
      <rect width="32" height="32" rx="9" className="fill-brand-600" />
      <path d="M9 10.5a6 6 0 0 1 6 6v5H12a3 3 0 0 1-3-3z" className="fill-accent" />
      <path d="M23 21.5a6 6 0 0 1-6-6v-5h3a3 3 0 0 1 3 3z" fill="#ffffff" />
    </svg>
  );
}

export function Logo({ to = '/', className }: { to?: string; className?: string }) {
  return (
    <Link to={to} className={cn('group inline-flex items-center gap-2.5 rounded-lg', className)} aria-label="PatrociConnect — página inicial">
      <LogoMark />
      <span className="font-display text-lg font-bold tracking-tight text-ink">
        Patroci<span className="text-brand-400">Connect</span>
      </span>
    </Link>
  );
}
